export const syntheticDataHeroData = {
  title: 'Synthetic Data Generation with Rumble Fish',
  description: (
    <>
      Custom <b>Synthetic Data</b> Solutions for Complex Product Challenges
    </>
  ),
};
